import RatingBreakdownTooltip from './RatingBreakdownTooltip'

export default RatingBreakdownTooltip
